import { URLSearchParams } from "url";

const REGION_CATEGORY_NATIONAL = 'national';
const REGION_CATEGORY_LOCAL = 'local';

class RegionSpecialsList {
    constructor(element) {
        this.element = element;
        this.specialsContainer = element.querySelector(".specials-list__container");

        this.showNationalBtn = element.querySelector(".show-national-btn");
        this.showLocalBtn = element.querySelector(".show-local-btn");
        this.itemsContainerLocal = element.querySelector(".specials-list__local-items");
        this.itemsContainerNational = element.querySelector(".specials-list__national-items");

        this.addEventListeners();
        this.filterAndShowNational();
    }

    addEventListeners () {
        this.showNationalBtn.addEventListener("click", this.filterAndShowNational.bind(this));
        this.showLocalBtn.addEventListener("click", this.filterAndShowLocal.bind(this));
        this.element.querySelector('#location').addEventListener("change", this.onChangeSelectLocationSpecial.bind(this));
    }    

    filterAndShowNational () {
        this.showItemsFromRegion(REGION_CATEGORY_NATIONAL);
        this.showNationalBtn.classList.add('active');
        this.showLocalBtn.classList.remove('active');
    }
    filterAndShowLocal () {
        this.showItemsFromRegion(REGION_CATEGORY_LOCAL);
        this.showLocalBtn.classList.add('active');
        this.showNationalBtn.classList.remove('active');
    }

    showItemsFromRegion(type) {
        this.itemsContainerLocal.style.display = 'none';
        this.itemsContainerNational.style.display = 'none';
        if (type === REGION_CATEGORY_NATIONAL) {
            this.itemsContainerNational.style.display = 'grid';
        } else {
            this.itemsContainerLocal.style.display = 'block';    
        }
    }

    onChangeSelectLocationSpecial() {        
        let blockId = document.getElementById('block-id');
        let location = '00000000';
        let locationSelector = document.getElementById('location');
        if (locationSelector)
        { 
            let selectedLocation = locationSelector.selectedOptions[0];
            if (selectedLocation)
            {
                location = selectedLocation.value;
            }
            
            let url = '/api/localpartsspecials/' + blockId.value + '/' + location;           
            
            fetch(url, {
                method: 'GET'
            }).then((response) => {
                return response.json();
            }).then((data) => {                
                if (data.statusCode = 200)
                {
                    this.populateSpecials(data.result);
                } else {

                }
            }).catch((err) => {

            })            
        }
    }

    populateSpecials(data) {
        // Get the container
        let parent = document.getElementById('local-list');

        // Remove existing specials
        while (parent.firstChild)
        {
            parent.removeChild(parent.firstChild)
        }       

        // Update the location name
        let locationName = document.getElementById('location-name'); 
        locationName.innerText = data.locationName;

        let locationNameTitle = document.getElementById('location-name-title'); 
        locationNameTitle.style.display = 'block';     

        // If there are specials
        if (data.specials.length > 0)
        {    
            //hide no results
            let noResults = document.getElementById('local-list-no-results');
            noResults.style.display = 'none';
            
            // Loop through the specials
            data.specials.forEach(function(special) { 

                if (special.specialType == 'PartsSpecial')
                {
                    // Make the card
                    let card = document.createElement('div');
                    card.className = 'specials-card specials-card--national-local';                              
        
                    // Make the content section
                    let contentSection = document.createElement('div');
                    contentSection.className = 'grid grid-md-2-cols';                
        
                    // Make the details
                    let details = document.createElement('div');
                    details.className = 'specials-card__details';

                    let title = document.createElement('div');
                    title.className ='specials-card__details-title--main';
                    let titleContent = document.createTextNode(special.title);
                    title.appendChild(titleContent);
                    details.appendChild(title);
                    
                    special.details.forEach(function(detail){                    
                        if (detail.text !== "Price")
                        {
                            let label = document.createElement('div');
                            label.className ='specials-card__details-title';
                            let textContent = document.createTextNode(detail.text);
                            label.appendChild(textContent);
                            details.appendChild(label);
                        }
                        if (detail.value.length > 0)
                        {
                            if(detail.text === "Price") {
                                let value = document.createElement('div');
                                value.className ='specials-card__details-title--highlight';
                                let valueContent = document.createTextNode(detail.value);
                                value.appendChild(valueContent);
                                details.appendChild(value)
                            }
                            else {
                                let value = document.createElement('span');
                                let valueContent = document.createTextNode(detail.value);
                                value.appendChild(valueContent);
                                details.appendChild(value)
                            }
                        }                    
                    })

                    // Add details to content section
                    contentSection.appendChild(details);

                    // Add the image
                    if (special.imageUrl.length > 0)
                    {
                        let imageContainer = document.createElement('div');
                        imageContainer.className = 'specials-card__img-container';

                        let image = document.createElement('img');
                        image.setAttribute('src',special.imageUrl);

                        imageContainer.appendChild(image);
                        contentSection.appendChild(imageContainer);
                    }

                    // Add the content to the card
                    card.appendChild(contentSection);                
        
                    // Make the cta section
                    let ctaSection = document.createElement('div');
                    ctaSection.className = 'specials-card__ctas-container';

                    // Make the first link
                    let innerDiv = document.createElement('div');

                    // Make the link
                    let linkOne = document.createElement('a');
                    linkOne.className = "button button--primary";
                    linkOne.setAttribute('href', special.linkUrl);
                    linkOne.setAttribute('target', special.linkTarget)
                    linkOne.setAttribute('title', special.linkTitle)

                    // Make the link text
                    let linkOneTextSpan = document.createElement('span');
                    let linkOneTextSpanContent = document.createTextNode(special.linkText);
                    linkOneTextSpan.appendChild(linkOneTextSpanContent);
                    linkOne.appendChild(linkOneTextSpan);
                    
                    // Make the link accessibility text
                    // if (data.findLocationCtaAccessibilityText.length > 0)
                    // {
                    //     let linkOneAccessibilitySpan = document.createElement('span');
                    //     linkOneAccessibilitySpan.className = 'visually-hidden';
                    //     let linkOneAccessibilitySpanContent = document.createTextNode(data.findLocationCtaAccessibilityText);
                    //     linkOneAccessibilitySpan.appendChild(linkOneAccessibilitySpanContent);
                    //     linkOne.appendChild(linkOneAccessibilitySpan);
                    // }

                    // Make the link chevron
                    let chevronSpan = document.createElement('span');
                    chevronSpan.classNAme = 'button__icon button__icon--right icon';

                    let chevronIcon = document.createElement('img');
                    chevronIcon.setAttribute('src','/dist/images/chevron-right.svg');
                    chevronSpan.appendChild(chevronIcon);
                    linkOne.appendChild(chevronSpan);

                    innerDiv.appendChild(linkOne);
                    ctaSection.appendChild(innerDiv);

                    // Make the second link
                    let secondInnerDiv = document.createElement('div');
                    let linkTwo = document.createElement('a');
                    linkTwo.className = "button button--secondary";
                    linkTwo.setAttribute('href', data.partsConnectUrl);

                    // Make the link text
                    let linkTwoTextSpan = document.createElement('span');
                    let linkTwoTextSpanContent = document.createTextNode(data.showPartsCtaText);
                    linkTwoTextSpan.appendChild(linkTwoTextSpanContent);
                    linkTwo.appendChild(linkTwoTextSpan);
                    
                    // Make the link accesibility text
                    if (data.showPartsCtaAccessibilityText.length > 0)
                    {
                        let linkTwoAccessibilitySpan = document.createElement('span');
                        linkTwoAccessibilitySpan.className = 'visually-hidden';
                        let linkTwoAccessibilitySpanContent = document.createTextNode(data.showPartsCtaAccessibilityText);
                        linkTwoAccessibilitySpan.appendChild(linkTwoAccessibilitySpanContent);
                        linkTwo.appendChild(linkTwoAccessibilitySpan);
                    }
                
                    // Add the chevron
                    linkTwo.appendChild(chevronSpan);

                    // Add to the section
                    secondInnerDiv.appendChild(linkOne);
                    ctaSection.appendChild(secondInnerDiv);

                    // Add the section to the card
                    card.appendChild(ctaSection);
                    
                    // Add the card to the page
                    parent.appendChild(card);   
                } else if (special.specialType == 'RichTextSpecial')
                {
                    // Make the card
                    let card = document.createElement('div');
                    card.className = 'specials-card specials-card--national-local';
        
                    // Make the details
                    let header = document.createElement('div');
                    header.className = 'specials-card__header';
                    let title = document.createTextNode(special.title);
                    header.appendChild(title);                                        

                    // Add the content to the card
                    card.appendChild(header);                
        
                    // Make the cta section
                    let body = document.createElement('div');
                    body.className = 'specials-card__body';

                    // Set the body text
                    let bodyDiv = document.createElement('div');
                    bodyDiv.innerHTML = special.bodyText;
                    body.appendChild(bodyDiv);

                    // Make the cta section
                    let ctaSection = document.createElement('div');
                    ctaSection.className = 'specials-card__ctas-container';

                    // Make the first link
                    let innerDiv = document.createElement('div');

                    // Make the link
                    let linkOne = document.createElement('a');
                    linkOne.className = "button button--primary";
                    linkOne.setAttribute('href', special.linkUrl);
                    linkOne.setAttribute('target', special.linkTarget)
                    linkOne.setAttribute('title', special.linkTitle)


                    // Make the link text
                    let linkOneTextSpan = document.createElement('span');
                    let linkOneTextSpanContent = document.createTextNode(special.linkText);
                    linkOneTextSpan.appendChild(linkOneTextSpanContent);
                    linkOne.appendChild(linkOneTextSpan);
                    
                    // Make the link accessibility text
                    // if (data.findLocationCtaAccessibilityText.length > 0)
                    // {
                    //     let linkOneAccessibilitySpan = document.createElement('span');
                    //     linkOneAccessibilitySpan.className = 'visually-hidden';
                    //     let linkOneAccessibilitySpanContent = document.createTextNode(data.findLocationCtaAccessibilityText);
                    //     linkOneAccessibilitySpan.appendChild(linkOneAccessibilitySpanContent);
                    //     linkOne.appendChild(linkOneAccessibilitySpan);
                    // }

                    // Make the link chevron
                    let chevronSpan = document.createElement('span');
                    chevronSpan.classNAme = 'button__icon button__icon--right icon';

                    let chevronIcon = document.createElement('img');
                    chevronIcon.setAttribute('src','/dist/images/chevron-right.svg');
                    chevronSpan.appendChild(chevronIcon);
                    linkOne.appendChild(chevronSpan);

                    innerDiv.appendChild(linkOne);
                    ctaSection.appendChild(innerDiv);

                    // Make the second link
                    let secondInnerDiv = document.createElement('div');
                    let linkTwo = document.createElement('a');
                    linkTwo.className = "button button--secondary";
                    linkTwo.setAttribute('href', data.partsConnectUrl);

                    // Make the link text
                    let linkTwoTextSpan = document.createElement('span');
                    let linkTwoTextSpanContent = document.createTextNode(data.showPartsCtaText);
                    linkTwoTextSpan.appendChild(linkTwoTextSpanContent);
                    linkTwo.appendChild(linkTwoTextSpan);
                    
                    // Make the link accesibility text
                    if (data.showPartsCtaAccessibilityText.length > 0)
                    {
                        let linkTwoAccessibilitySpan = document.createElement('span');
                        linkTwoAccessibilitySpan.className = 'visually-hidden';
                        let linkTwoAccessibilitySpanContent = document.createTextNode(data.showPartsCtaAccessibilityText);
                        linkTwoAccessibilitySpan.appendChild(linkTwoAccessibilitySpanContent);
                        linkTwo.appendChild(linkTwoAccessibilitySpan);
                    }
                
                    // Add the chevron
                    linkTwo.appendChild(chevronSpan);

                    // Add to the section
                    secondInnerDiv.appendChild(linkOne);
                    ctaSection.appendChild(secondInnerDiv);

                    // Add the section to the card
                    card.appendChild(body);

                    card.appendChild(ctaSection);
                    
                    // Add the card to the page
                    parent.appendChild(card);   
                }                
            })   
        } else {
            // Show no results
            let noResults = document.getElementById('local-list-no-results');
            noResults.style.display = 'block';
        }
    }

}

export default RegionSpecialsList;
